import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {defineCssVars, defineStyleConfig} from '@chakra-ui/styled-system';

export const {
  height: $height,
  maxHeight: $maxHeight,
  color: $color,
  fontSize: $fontSize,
  lineHeight: $lineHeight,
  fontWeight: $fontWeight,
  paddingX: $paddingX,
  paddingY: $paddingY,
  backgroundColor: $backgroundColor,
} = defineCssVars(`td`, [
  `height`,
  `maxHeight`,
  `color`,
  `backgroundColor`,
  `fontSize`,
  `lineHeight`,
  `fontWeight`,
  `paddingX`,
  `paddingY`,
]);

export const tdCssVars = (_props: StyleFunctionProps) => ({
  [$height.variable]: `fit-content`,
  [$maxHeight.variable]: `sizes.60`,
  [$color.variable]: `colors.text.base`,
  [$fontSize.variable]: `fontSizes.sm`,
  [$lineHeight.variable]: `normal`,
  [$fontWeight.variable]: `normal`,
  [$paddingX.variable]: `space.8`,
  [$paddingY.variable]: `space.8`,
  [$backgroundColor.variable]: `transparent`,
});

export const tdStyle = defineStyleConfig({
  baseStyle: {
    position: `relative`,
    // Typography
    fontSize: $fontSize.reference,
    lineHeight: $lineHeight.reference,
    fontWeight: $fontWeight.reference,
    color: $color.reference,
    bg: $backgroundColor.reference,

    // Spacing
    padding: `${$paddingY.reference} ${$paddingX.reference}`,

    // overrides
    paddingInlineEnd: `0`,
    paddingInlineStart: `0`,
    py: `unset`,
    px: `unset`,
  },
});
